var ScriptsVanillaJs = (function () {
  var promoBar, headerElem;

  return {
    init: init,
  };

  function init() {
    headerElem = document.getElementById("header-habitat");

    uiBindings();
  }

  function uiBindings() {
    function handleScrollAndResizeEvents() {
      globaltickyHeader();
    }

    window.addEventListener('scroll', handleScrollAndResizeEvents);
    window.addEventListener('resize', handleScrollAndResizeEvents);

    // One Page Smooth Scroll
    smoothScrollFunc();
  }
  
  /**
   * Function to handle sticky header behavior
   */
  function globaltickyHeader() {
    if (headerElem && window.innerWidth > 979) {
      promoBar = document.getElementById('promo-notification');
      headerHabitatWrap = document.getElementById('header-habitat-wrap');
      var yScroll = window.pageYOffset;

      // Adjust top position based on promo bar visibility
      if (promoBar) {
        if (yScroll < promoBar.offsetHeight) {
          headerHabitatWrap.style.top = -yScroll + 'px';
        } else {
          headerHabitatWrap.style.top = -promoBar.offsetHeight + 'px';
        }
      } 
    }
  }

  /**
   * One Page Smooth Scroll
   */
  function smoothScrollFunc() {
    var scrollClicks = document.querySelectorAll('[data-scrollto], .one-page-scroll');
    for (var k = 0; k < scrollClicks.length; k++) {
      scrollClicks[k].addEventListener('click', function (e) {
        var scrollClick = this,
          ieVersion = bsLib.msieversion();
        /**
         * Check if ie version less than 11 then dont add  e.preventDefault().
         */
        if (!ieVersion || ieVersion >= 11) {
          e.preventDefault();
        }
        var scrollTarget = scrollClick.getAttribute('data-scrollto');
        if (!scrollTarget) {
          var href = scrollClick.getAttribute('href');
          // Extract only the anchor/hash portion from the href
          // This handles URLs like "#section" or "page?query=1#section"
          if (href && href.indexOf('#') > -1) {
            scrollTarget = href.substring(href.indexOf('#'));
          } else {
            scrollTarget = href;
          }
        }
        if (scrollTarget && document.querySelector(scrollTarget)) {
          smoothScroll(scrollTarget, 1000);
        }
      });
    }
  }

  /**
     * Smooth Scroll to anchor on Click
     * https://www.youtube.com/watch?v=oUSvlrDTLi4
     */

    function smoothScroll(target, duration) {
      var target = document.querySelector(target),
        headerElem = document.getElementById("header-habitat"),
        targetPosition =
          target.getBoundingClientRect().top - (headerElem ? headerElem.offsetHeight: 0) + window.pageYOffset,
        startPosition = window.pageYOffset,
        distance = targetPosition - startPosition,
        startTime = null; 

      function scrollAnimation(currentTime) {
        if (startTime === null) {
          startTime = currentTime;
        }
        var timeElapsed = currentTime - startTime;
        var run = ease(timeElapsed, startPosition, distance, duration);
        window.scrollTo(0, run);
        if (timeElapsed < duration) {
          requestAnimationFrame(scrollAnimation);
        }
      }

      /**
       * Easing Functions
       * http://www.gizma.com/easing/
       */
      function ease(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return (c / 2) * t * t + b;
        t--;
        return (-c / 2) * (t * (t - 2) - 1) + b;
      }
      requestAnimationFrame(scrollAnimation);
    }
    
})();

ScriptsVanillaJs.init();

